import { LINKS } from "../../config/links";

const BULLETS = [
  "5 proven ChatGPT prompts for advisor posts that convert",
  "A simple Canva system to make it look premium in minutes",
  "Hook + CTA frameworks that trigger DMs and bookings",
  "Real examples pulled from the Medicare funnel",
];

export default function LeadMagnet() {
  return (
    <section
      id="free-guide"
      data-testid="lead-magnet-section"
      className="relative py-20 sm:py-24 border-y border-white/10 bg-gradient-to-br from-[#0e1e44]/70 to-[#0a1733]/80 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute top-1/2 left-1/4 -translate-y-1/2 h-[360px] w-[600px] bg-amber-500/[0.06] blur-[120px] rounded-full" aria-hidden />
      </div>

      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* LEFT — Copy */}
          <div className="lg:col-span-7">
            <div className="reveal flex items-center gap-3 mb-5">
              <span className="h-[1px] w-10 bg-amber-500/70" />
              <span className="font-sans-body uppercase text-[11px] tracking-[0.32em] text-amber-400">
                Free Download
              </span>
            </div>

            <h2
              data-testid="lead-magnet-headline"
              className="reveal font-display font-light text-white text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-[-0.01em] text-balance"
              style={{ transitionDelay: "80ms" }}
            >
              The Financial Advisor{" "}
              <span className="italic text-amber-400">Content Kit.</span>
            </h2>

            <p
              className="reveal mt-5 text-slate-300 text-base sm:text-lg leading-relaxed max-w-xl"
              style={{ transitionDelay: "140ms" }}
            >
              Learn how to create content that actually converts into
              appointments — using 5 proven ChatGPT prompts and a simple
              Canva system.
            </p>

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              {BULLETS.map((b, i) => (
                <li
                  key={b}
                  data-testid={`lead-magnet-bullet-${i}`}
                  className="reveal flex items-start gap-3 text-sm text-slate-200"
                  style={{ transitionDelay: `${180 + i * 50}ms` }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    className="text-amber-400 mt-0.5 shrink-0"
                  >
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            <div className="reveal mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href={LINKS.leadMagnet}
                data-testid="lead-magnet-cta-download"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-center gap-3 bg-amber-600 hover:bg-amber-500 text-slate-950 font-semibold px-8 py-4 text-[13px] uppercase tracking-[0.18em] transition-all duration-300 hover:-translate-y-0.5"
              >
                Give Me the 5 Prompts
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" className="transition-transform group-hover:translate-y-0.5">
                  <path d="M12 3v14M5 12l7 7 7-7M5 21h14" />
                </svg>
              </a>
              <a
                href={LINKS.calendar}
                data-testid="lead-magnet-cta-call"
                className="inline-flex items-center justify-center gap-3 border border-white/20 hover:border-amber-400/60 text-white hover:text-amber-300 px-8 py-4 text-[13px] uppercase tracking-[0.18em] transition-all duration-300"
              >
                Or Book A Strategy Call
              </a>
            </div>

            <p className="reveal mt-5 text-xs uppercase tracking-[0.2em] text-slate-500">
              Instant PDF · Zero cost · No upsell
            </p>
          </div>

          {/* RIGHT — Book/kit visual */}
          <div className="lg:col-span-5 flex justify-center">
            <div
              data-testid="lead-magnet-visual"
              className="reveal relative w-full max-w-[360px] aspect-[3/4] bg-gradient-to-br from-slate-900 to-slate-950 border border-amber-500/30 p-8 flex flex-col justify-between shadow-[0_30px_80px_rgba(0,0,0,0.5)] hover:-translate-y-1 transition-transform duration-500"
              style={{ transitionDelay: "200ms" }}
            >
              <span className="absolute top-0 left-0 h-1 w-full bg-amber-500" />
              <span className="absolute top-0 left-0 h-full w-1 bg-amber-500/40" />

              <div>
                <div className="font-sans-body uppercase text-[10px] tracking-[0.32em] text-amber-400 mb-2">
                  Zivae Marketing
                </div>
                <div className="font-sans-body uppercase text-[10px] tracking-[0.24em] text-slate-500">
                  Digital Kit · Free
                </div>
              </div>

              <div>
                <div className="text-[11px] uppercase tracking-[0.2em] text-slate-400 mb-3">
                  Volume 01
                </div>
                <h3 className="font-display text-3xl sm:text-[34px] text-white leading-[1.05]">
                  The Financial Advisor Content Kit
                </h3>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">
                  5 ChatGPT prompts · A simple Canva system · Converting content in minutes.
                </p>
              </div>

              <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.28em] text-slate-500 pt-6 border-t border-white/5">
                <span>PDF</span>
                <span>Instant Download</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
